import { AxiosPromise } from 'axios';
import * as Yup from 'yup';

import IUser from '../interfaces/user.interface';
import api from './api';

export type IUserSignInData = {
  email: string;
  password: string;
};

export type IUserSignInResponse = {
  user: IUser;
  data: {
    token: string;
    expires_at: string;
  };
};

export const UserSignInDataSchema = Yup.object().shape({
  email: Yup.string()
    .email(`O campo deve conter um e-mail válido`)
    .required(`E-mail é um campo obrigatório`),
  password: Yup.string()
    .min(6, (v) => `A senha deve conter no mínimo ${v.min} caracteres`)
    .required(`Senha é um campo obrigatório`),
});

export const UserService = {
  signIn(data: IUserSignInData): AxiosPromise<IUserSignInResponse> {
    return api.post('auth/signin', data);
  },
};
